import { Badge } from 'antd';
import { useMemo } from 'react';
import { UserRole } from '@/constants';
import { useUserStore } from '@/stores';

type ScriptActiveBadgeProps = {
    isActive: boolean;
};

export const ScriptActiveBadge = ({ isActive }: ScriptActiveBadgeProps) =>
{
    const { user } = useUserStore();

    const isManager = useMemo(() => user?.role === UserRole.Manager, [user?.role]);

    if (isManager) {
        return;
    }

    return (
        <Badge
            status={isActive ? 'success' : 'default'}
            text={isActive ? 'Активний' : 'Неактивний'}
        />
    );
};
